import { render, staticRenderFns } from "./DataResources.vue?vue&type=template&id=6a094ae7&"
import script from "./DataResources.vue?vue&type=script&lang=js&"
export * from "./DataResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports